// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  ViewListOutlined,
  ViewModuleOutlined,
} from '@/constants/hardfin-standard-icons';
import { InventoryDimension } from '@/inventory/hooks';

export const INVENTORY_VIEW_OPTIONS: FilterOption<InventoryDimension>[] = [
  {
    value: 'item',
    label: 'Item',
    icon: <ViewModuleOutlined fontSize="small" />,
  },
  {
    value: 'location',
    label: 'Location',
    icon: <ViewListOutlined fontSize="small" />,
  },
];
